import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["audio", "playPauseBtn", "playIcon", "pauseIcon", "waveformCanvas", "currentTime", "totalTime"]

  connect() {
    this.isPlaying = false
    this.waveformData = []
    this.initializeAudio()
  }

  initializeAudio() {
    this.generateWaveform()
    this.setupEventListeners()
  }

  generateWaveform() {
    const canvas = this.waveformCanvasTarget
    const ctx = canvas.getContext('2d')
    const width = canvas.width
    const height = canvas.height

    // Generate random waveform data
    this.waveformData = []
    for (let i = 0; i < width; i += 4) {
      this.waveformData.push(Math.random() * height)
    }

    this.drawWaveform()
  }

  drawWaveform() {
    const canvas = this.waveformCanvasTarget
    const ctx = canvas.getContext('2d')
    const width = canvas.width
    const height = canvas.height

    ctx.clearRect(0, 0, width, height)

    // Draw waveform bars
    ctx.fillStyle = '#667781'
    for (let i = 0; i < this.waveformData.length; i++) {
      const barHeight = this.waveformData[i]
      const x = i * 4
      const y = (height - barHeight) / 2

      ctx.fillRect(x, y, 2, barHeight)
    }
  }

  updateProgress() {
    if (this.audioTarget.duration) {
      const progress = (this.audioTarget.currentTime / this.audioTarget.duration) * 100
      const canvas = this.waveformCanvasTarget
      const ctx = canvas.getContext('2d')
      const width = canvas.width
      const height = canvas.height

      // Clear and redraw with progress
      ctx.clearRect(0, 0, width, height)

      // Draw background bars
      ctx.fillStyle = '#667781'
      for (let i = 0; i < this.waveformData.length; i++) {
        const barHeight = this.waveformData[i]
        const x = i * 4
        const y = (height - barHeight) / 2

        ctx.fillRect(x, y, 2, barHeight)
      }

      // Draw progress bars
      ctx.fillStyle = '#25d366'
      const progressWidth = (progress / 100) * width

      for (let i = 0; i < this.waveformData.length; i++) {
        const barHeight = this.waveformData[i]
        const x = i * 4
        const y = (height - barHeight) / 2

        if (x < progressWidth) {
          ctx.fillRect(x, y, 2, barHeight)
        }
      }
    }
  }

  formatTime(seconds) {
    const mins = Math.floor(seconds / 60)
    const secs = Math.floor(seconds % 60)
    return `${mins}:${secs.toString().padStart(2, '0')}`
  }

  updateTime() {
    this.currentTimeTarget.textContent = this.formatTime(this.audioTarget.currentTime)
    this.updateProgress()
  }

  togglePlayPause() {
    if (this.isPlaying) {
      this.audioTarget.pause()
      this.playIconTarget.style.display = 'block'
      this.pauseIconTarget.style.display = 'none'
      this.isPlaying = false
    } else {
      this.audioTarget.play()
      this.playIconTarget.style.display = 'none'
      this.pauseIconTarget.style.display = 'block'
      this.isPlaying = true
    }
  }

  handleCanvasClick(event) {
    const canvas = this.waveformCanvasTarget
    const rect = canvas.getBoundingClientRect()
    const x = event.clientX - rect.left
    const progress = x / canvas.width

    if (this.audioTarget.duration) {
      this.audioTarget.currentTime = progress * this.audioTarget.duration
    }
  }

  setupEventListeners() {
    this.playPauseBtnTarget.addEventListener('click', () => this.togglePlayPause())
    this.waveformCanvasTarget.addEventListener('click', (event) => this.handleCanvasClick(event))

    this.audioTarget.addEventListener('loadedmetadata', () => {
      this.totalTimeTarget.textContent = this.formatTime(this.audioTarget.duration)
    })

    this.audioTarget.addEventListener('timeupdate', () => this.updateTime())

    this.audioTarget.addEventListener('ended', () => {
      this.playIconTarget.style.display = 'block'
      this.pauseIconTarget.style.display = 'none'
      this.isPlaying = false
      this.audioTarget.currentTime = 0
      this.updateProgress()
    })
  }
}
